export default ({ logoABT, logoComp }) => [
  {
    title: 'А-БТ', data: logoABT, parentName: 'logoABT',
  },
  {
    title: 'Лого </br>компании', data: logoComp, parentName: 'logoComp',
  },
];
